module.exports = __webpack_public_path__ + "media/images/icon-hamburger-c1d162e6053b0e0e13b3ff9a067bc9c8.svg";